<template>
<v-container fluid>
  <v-card>
    <v-card-title>
      <span class="headline mb-0">冻结时间配置</span>
    </v-card-title>
    <v-card-actions>
      <v-btn @click="save()" :disabled="!valid">{{
          $t('app.buttons.save')
        }}</v-btn>
      <v-btn @click="$router.go(-1)">{{ $t('app.buttons.back') }}</v-btn>
    </v-card-actions>
    <v-form v-model="valid">
      <v-container fluid>
        <v-layout wrap>
          <v-flex md3 sm6 xs6>
            <v-select
            :rules="[(v) => v != null || `冻结类型 is required`]"
                :items="archiveTypes"
                clearable
                item-text="text"
                item-value="value"
                label="冻结类型"
                v-model="root.archiveType"
              ></v-select>

          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex md3 sm6 xs6>
            <v-text-field
            :rules="[(v) => v != null || `冻结日期 is required`]"
                  label="冻结日期"
                  v-model.trim="root.archiveDay"
                ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</v-container>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      valid: null,
      id: null,
      root: {},
      archiveTypes: [
        {
          text: 'AP国际段第一次冻结',
          value: 'AP_INTERNATIONAL_PHASE_ONE',
        },
        {
          text: 'AP国际段第二次冻结',
          value:'AP_INTERNATIONAL_PHASE_TWO',
        },
        {
          text: 'AP国内端冻结',
          value: 'AP_LOCAL',
        },
        {
          text: 'AR冻结',
          value: 'AR',
        },
      ],
    }
  },
  methods: {
    returnToList() {
      this.$router.push({
        name: 'M2500',
      })
    },
    initData() {
      this.root.code = this.$route.query.code
      this.root.name = this.$route.query.name
    },
    save() {
      this.$http
        .post(`/archive-configs`, this.root)
        .then(() => {
          this.returnToList()
          this.$message('', 'Success')
        })
        .catch(() => {
          this.$message('', 'Error')
        })
    },
  },
  mounted() {
    this.initData()
  },
}
</script>
